<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Voyage List</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="voyNo" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.voyNo }}</td>
        <td class="text-xs-left">{{ props.item.voyDet }}</td>
        <td class="text-xs-left">{{ formatDateTime2(props.item.estDeptDate) }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" review @review="doReview(props.item)" :loading="loading" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-card-text>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        Add Voyage
        <v-icon right>mdi-table-row-plus-before</v-icon>
      </v-btn>
    </v-card-text>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Voyage? ({{deleteVoyage}})
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { VESSEL_VOYAGE_TABMENU } from '@/store/types'
import { formatDisplayDateTime2 } from '@/utils/date'
import toDate from 'date-fns/toDate'

export default {
  data() {
    return {
      headers: [
        { text: 'Voyage No', align: 'left', value: 'voyNo', sortable: false },
        { text: 'Voyage Detail', align: 'left', value: 'voyDet', sortable: false },
        { text: 'Estimated Departure Date', align: 'left', value: 'fact1', sortable: false },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      loading: false,
      items: [],
      promptRemove: false,
      selectedVoyage: undefined,
      deleteVoyage: ''
    }
  },
  computed: {
  },
  methods: {
    async doInit() {
      const commitData = {
        voyageTab: 0,
        displayVoyageReviewTab: false,
        vesNo: undefined
      }
      this.$store.commit(VESSEL_VOYAGE_TABMENU, commitData)
      await this.queryVesselVoyages()
    },
    doReview(data) {
      const commitData = {
        voyageTab: 1,
        displayVoyageReviewTab: true,
        vesNo: undefined
      }

      this.$store.commit(VESSEL_VOYAGE_TABMENU, commitData)
      this.$router.push({ name: 'voyageReview', params: { voyNo: data.voyNo } })
    },
    doNew() {
      const commitData = {
        voyageTab: 1,
        displayVoyageReviewTab: true
      }
      this.$store.commit(VESSEL_VOYAGE_TABMENU, commitData)
      this.$router.push({ name: 'voyageReview', params: { voyNo: 'New' } })
    },
    async queryVesselVoyages() {
      const apiURI = this.$store.state.vessel.menu.getVslVoyages
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            vesNo: this.vesNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((vesselVoyage) => {
                const convertVesselVoyage = {
                  voyNo: vesselVoyage.voyNo,
                  voyDet: vesselVoyage.voyDet,
                  estDeptDate: toDate(vesselVoyage.estDeptDate)
                }
                this.items.push(convertVesselVoyage)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        data.vesNo = this.vesNo
        this.selectedVoyage = data
        this.deleteVoyage = data.voyNo + ' - ' + data.voyDet
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.vessel.menu.deleteVoyage
      if (apiURI) {
        const expand = this.selectedVoyage
        this.$http.post(apiURI, expand).then(result => {
          const data = result.data
          this.notify(data)
          this.doInit()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  props: {
    vesNo: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
